interface CsvResult {
  idesk: { [key: string]: string }[];
  lexware: { [key: string]: string }[];
}

export interface OriginalEvent {
  [key: string]: string;
}

export interface TransformedEvent {
  title: string;
  start: Date;
  end: Date;
  allDay: boolean;
  resource: {
    longTitle: string;
    description: string;
    link: string[];
    topic: string;
  };
}

export function readCSV(): Promise<CsvResult> {
  return new Promise((resolve, reject) => {
    const Lexware: { [key: string]: string }[] = [];
    const iDesk: { [key: string]: string }[] = [];

    const expectedColumns: string[] = [
      "Datum",
      "Kurztitel",
      "Titel",
      "Beschreibung",
      "LexwareLink",
      "IDESK-PRODUKT",
      "IDESKLink",     
      "Initialen",
      "RubrikIDESK",
      "RubrikLexware",
    ];

    const delimiter = ";";

    fetch("./source_data_2026.csv")
      .then((response) => response.text())
      .then((data) => {
        const rows = data.replace(/\r\n/g, "\n").split("\n");
        const firstRow = rows[0].split(delimiter).map((h) => h.trim());

        // Validate all expected columns are present
        for (const col of expectedColumns) {
          if (!firstRow.includes(col)) {
            reject(new Error("Wrong Headline. Missing column: " + col));
            return;
          }
        }

        const rowsToProcess = rows.slice(1).filter((row) => row.trim() !== "");

        for (const row of rowsToProcess) {
          const columnData = row.split(delimiter);

          const convert: { [key: string]: string } = {};
          for (let n = 0; n < firstRow.length; n++) {
            convert[firstRow[n]] = columnData[n] !== undefined ? columnData[n].trim() : "";
          }

          const initialen = convert["Initialen"] ?? "";

          if (initialen === "Lexware" || initialen === "Both") {
            Lexware.push(convert);
          }
          if (initialen === "IDESK" || initialen === "Both") {
            iDesk.push(convert);
          }

          // Warn about unexpected Initialen values
          if (!["Lexware", "Both", "IDESK", ""].includes(initialen)) {
            console.warn(`Unexpected Initialen value "${initialen}" in row:`, convert["Kurztitel"]);
          }
        }

        resolve({ idesk: iDesk, lexware: Lexware });
      })
      .catch((error) => {
        console.error("CSV fetch error:", error);
        reject(error);
      });
  });
}